var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M8 10.9c.7 0 1.25-.55 1.25-1.23C9.25 9 8.7 8.43 8 8.43c-.7 0-1.25.56-1.25 1.24 0 .68.56 1.23 1.25 1.23zm3.75-5.57h-.63V4.1C11.13 2.4 9.72 1 8 1 6.28 1 4.87 2.4 4.87 4.1v1.23h-.62C3.55 5.33 3 5.9 3 6.57v6.2c0 .67.56 1.23 1.25 1.23h7.5c.7 0 1.25-.56 1.25-1.24v-6.2c0-.67-.56-1.23-1.25-1.23zM6.05 4.1c0-1.06.88-1.92 1.95-1.92 1.07 0 1.94.86 1.94 1.92v1.23H6.06V4.1zm5.7 8.66h-7.5v-6.2h7.5v6.2z"}));
}

Lock.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = Lock;

Lock.default = Lock;
